<template>
  <div
    style="position: relative;height: 100%;background: #EEEEEE;"
  >
    <div
      v-if="loading"
      style="position: absolute;top: 0;left: 0;bottom:0;right:0;width: 100%;height: 100%;background: rgba(255,255,255,0.7);z-index:10;display: flex;justify-content: center;align-items: center;flex-direction: column;"
    >
      <v-progress-circular
          :size="$vuetify.breakpoint.xs ? 100 : 150"
          :width="$vuetify.breakpoint.xs ? 10 : 15"
          indeterminate
          :color="getDomainInfo && getDomainInfo.primary_color ? getDomainInfo.primary_color : 'primary'"
      />
      <h2
          style="margin-top: 20px;font-weight: normal;color: rgba(0,0,0,0.6);"
      >
          Just a moment...
      </h2>
    </div>

    <v-layout
      v-else-if="matchingCases.length > 1 && scope === 'c'"
      row wrap justify-center align-center style="min-height: 100vh; padding: 20px;"
    >
      <v-flex xs12 sm10 md8 lg6>
        <v-card flat color="transparent">
          <v-card-text style="text-align: center;">
            <div
                style="font-size: 24px; font-weight: 700; margin-bottom: 20px; color: rgba(0,0,0,0.8);"
            >
                Select a Case
            </div>
            <div
                style="font-size: 18px; font-weight: 300; margin-bottom: 20px; color: rgba(0,0,0,0.8);"
            >
                The link you followed references multiple cases. Please select the case you'd like to open:
            </div>
            <v-list two-line>
              <v-list-tile
                v-for="c in matchingCases"
                :key="c.id"
                @click="selectCase(c)"
                style="border-bottom: 1px solid #f0f0f0;"
              >
                <v-list-tile-avatar>
                  <img :src="getIconPath(c.case_type.id)" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title style="font-weight: bold; font-size: 18px;">{{ c.case_type.name }}</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <span v-if="c.case_number" style="font-weight: bold;">{{ c.case_number }}</span>
                    <span v-if="c.case_title" style="font-style: italic;">({{ c.case_title }})</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-btn color="primary" small>Select</v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout
      v-else-if="Object.keys(matchingFormsByCase).length > 0 && scope === 'f'"
      row wrap justify-center align-center style="min-height: 100vh; padding: 20px;"
    >
      <v-flex xs12 sm10 md8 lg8>
        <v-card flat color="transparent">
          <v-card-text style="text-align: center;">
            <div
                style="font-size: 24px; font-weight: 700; margin-bottom: 20px; color: rgba(0,0,0,0.8);"
            >
                Select a Form
            </div>
            <div
                style="font-size: 18px; font-weight: 300; margin-bottom: 20px; color: rgba(0,0,0,0.8);"
            >
                You have multiple forms that reference the link you followed. Please select the form you'd like to open:
            </div>
            
            <div v-for="(caseData, caseId) in matchingFormsByCase" :key="caseId" style="margin-bottom: 25px; text-align: left;">
              <div style="display: flex; align-items: center; background: #f5f5f5; padding: 10px; border-radius: 4px;">
                  <img :src="getIconPath(caseData.case.case_type.id)" style="max-height: 40px; margin-right: 15px;" />
                  <div style="flex-grow: 1;">
                      <div style="font-weight: bold; font-size: 16px;">{{ caseData.case.case_type.name }}</div>
                      <div>
                          <span v-if="caseData.case.case_number" style="font-weight: bold;">{{ caseData.case.case_number }}</span>
                          <span v-if="caseData.case.case_title" style="font-style: italic;">({{ caseData.case.case_title }})</span>
                      </div>
                  </div>
              </div>
              <v-list two-line>
                <v-list-tile
                  v-for="form in caseData.forms"
                  :key="form.id"
                  @click="selectForm(caseData.case, form)"
                  style="border-bottom: 1px solid #f0f0f0;"
                >
                  <v-list-tile-avatar>
                      <v-icon size="32">mdi-file-document</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title style="font-weight: bold;">
                        {{ form.name }}
                        <span v-if="form.party_name"> - {{ form.party_name }}</span>
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                        <span v-if="form.form_number" style="font-style: italic;">({{ form.form_number }})</span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn v-if="form.is_signing" color="warning" small depressed>Sign</v-btn>
                    <v-btn v-else-if="form.is_new" color="green" dark small depressed>Start</v-btn>
                    <v-btn v-else color="primary" small depressed>Open</v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
    name: 'FuzzyLinkHandler',
    data () {
        return {
            scope: null,
            casetypeId: null,
            templateId: null,
            loading: true,
            matchingCases: [],
            matchingFormsByCase: {}
        }
    },
    created () {
        const path = this.$route.path
        if (path.startsWith('/link/c/')) {
            this.scope = 'c'
            this.casetypeId = parseInt(this.$route.params.casetype_id)
            this.templateId = this.$route.params.opt_id ? parseInt(this.$route.params.opt_id) : null
            this.resolveCaseLink()
        } else if (path.startsWith('/link/f/')) {
            this.scope = 'f'
            this.templateId = parseInt(this.$route.params.template_id)
            this.resolveFormLink()
        } else {
            this.$router.replace({ name: 'Home' })
        }
    },
    computed: {
        ...mapGetters('auth', [
            'getDomainInfo',
        ]),
        ...mapGetters('userform', [
            'signedForms',
        ]),
    },
    methods: {
        getIconPath (id) {
            return api.cases.casetype.icon(id)
        },
        resolveCaseLink() {
            api.userform.contactCases.list({ count: 50 })
                .then(data => {
                    const cases = data.results
                    let matchingCases = cases.filter(c => c.case_type && c.case_type.id === this.casetypeId)

                    if (matchingCases.length === 0) {
                        this.loading = false
                        this.$router.replace({ name: 'Home', query: { notice: "You don't have a case matching the link you followed." } })
                        return
                    }

                    if (!this.templateId) {
                        this.matchingCases = matchingCases
                        if (this.matchingCases.length === 1) {
                            this.selectCase(this.matchingCases[0])
                        } else {
                            this.loading = false
                        }
                    } else {
                        let casePromises = matchingCases.map(c => api.userform.contactCases.get(c.id))
                        Promise.all(casePromises)
                            .then(allCaseData => {
                                let validCases = []
                                allCaseData.forEach(caseData => {
                                    if (caseData && caseData.userforms) {
                                        const matchingForms = caseData.userforms.filter(
                                            form => form.template === this.templateId && ((!form.client_readonly || form.is_signing) && !this.signedForms.includes(form.id))
                                        )
                                        if (matchingForms.length > 0) {
                                            validCases.push(caseData)
                                        }
                                    }
                                })
                                
                                this.matchingCases = validCases

                                if (this.matchingCases.length === 0) {
                                    this.loading = false
                                    this.$router.replace({ name: 'Home', query: { notice: "You don't have a form matching the link you followed." } })
                                } else if (this.matchingCases.length === 1) {
                                    this.selectCase(this.matchingCases[0])
                                } else {
                                    this.loading = false
                                }
                            })
                            .catch(err => {
                                this.loading = false
                                this.$router.replace({ name: 'Home', query: { notice: "An error occurred while matching your link." } })
                            })
                    }
                })
                .catch(err => {
                    this.loading = false
                    this.$router.replace({ name: 'Home', query: { notice: "You don't have a case matching the link you followed." } })
                })
        },
        selectCase(selectedCase) {
            this.loading = true
            if (!this.templateId) {
                this.$router.replace({ name: 'Forms', params: { id: selectedCase.id } })
                return
            }

            api.userform.contactCases.get(selectedCase.id)
                .then(caseData => {
                    if (caseData && caseData.userforms) {
                        const matchingForms = caseData.userforms.filter(
                            form => form.template === this.templateId && ((!form.client_readonly || form.is_signing) && !this.signedForms.includes(form.id))
                        )
                        if (matchingForms.length === 1) {
                            this.$router.replace({ name: 'ClientForm', params: { id: selectedCase.id, form_id: matchingForms[0].id } })
                        } else if (matchingForms.length > 1) {
                            this.matchingFormsByCase = {
                                [selectedCase.id]: {
                                    case: selectedCase,
                                    forms: matchingForms
                                }
                            }
                            this.scope = 'f'
                            this.loading = false
                        } else {
                            this.$router.replace({ name: 'Forms', params: { id: selectedCase.id }, query: { notice: "You don't have an outstanding form matching the link you followed." } })
                        }
                    } else {
                        this.$router.replace({ name: 'Forms', params: { id: selectedCase.id }, query: { notice: "You don't have an outstanding form matching the link you followed." } })
                    }
                })
                .catch(err => {
                    this.$router.replace({ name: 'Forms', params: { id: selectedCase.id }, query: { notice: "You don't have an outstanding form matching the link you followed." } })
                })
        },
        resolveFormLink() {
            api.userform.contactCases.list({ count: 50 })
                .then(data => {
                    const cases = data.results
                    let casePromises = cases.map(c => api.userform.contactCases.get(c.id))
                    
                    Promise.all(casePromises)
                        .then(allCaseData => {
                            let totalFormsFound = 0
                            let formsByCase = {}
                            let singleMatchingCase = null
                            let singleMatchingForm = null

                            allCaseData.forEach(caseData => {
                                if (caseData && caseData.userforms) {
                                    const matchingForms = caseData.userforms.filter(
                                        form => form.template === this.templateId && ((!form.client_readonly || form.is_signing) && !this.signedForms.includes(form.id))
                                    )
                                    if (matchingForms.length > 0) {
                                        formsByCase[caseData.id] = {
                                            case: caseData,
                                            forms: matchingForms
                                        }
                                        totalFormsFound += matchingForms.length
                                        singleMatchingCase = caseData
                                        singleMatchingForm = matchingForms[0]
                                    }
                                }
                            })

                            if (totalFormsFound === 0) {
                                this.loading = false
                                this.$router.replace({ name: 'Home', query: { notice: "You don't have a form matching the link you followed." } })
                            } else if (totalFormsFound === 1) {
                                this.selectForm(singleMatchingCase, singleMatchingForm)
                            } else {
                                this.matchingFormsByCase = formsByCase
                                this.loading = false
                            }
                        })
                        .catch(err => {
                            this.loading = false
                            this.$router.replace({ name: 'Home', query: { notice: "You don't have a form matching the link you followed." } })
                        })
                })
                .catch(err => {
                    this.loading = false
                    this.$router.replace({ name: 'Home', query: { notice: "You don't have a form matching the link you followed." } })
                })
        },
        selectForm(selectedCase, selectedForm) {
            this.$router.replace({ name: 'ClientForm', params: { id: selectedCase.id, form_id: selectedForm.id } })
        }
    }
}
</script>

<style scoped>
.v-list {
  background: transparent;
}
.v-list__tile {
  background: white;
  margin-bottom: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  border: none !important;
}
</style>
